import { render } from "./EventLocation.vue?vue&type=template&id=39a31f43&scoped=true"
import script from "./EventLocation.vue?vue&type=script&lang=js"
export * from "./EventLocation.vue?vue&type=script&lang=js"

import "./EventLocation.vue?vue&type=style&index=0&id=39a31f43&scoped=true&lang=css"
import "./EventLocation.vue?vue&type=style&index=1&id=39a31f43&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a31f43"]])

export default __exports__